// extracted by mini-css-extract-plugin
export default {"melodyRule":"fG-z"};